import { getTranslations } from "../../translations";

window.addEventListener("load", (event: Event) =>
{
    //initPaging(true, true);
});

// TODO: Move all paging to this file.
function initPaging(rebuild: boolean, initial: boolean): void
{
    return;

    /*
    if (initial && getParameterByName("page").length > 0) 
    {
        const tmpPage = parseInt(getParameterByName("page"), 10);

        if (tmpPage > 1)
            initialPageNumber = tmpPage;
    }

    if (rebuild) 
    {
        $(".pager").prev(".clear").remove();
        $(".pager").remove();

        const $clearDiv = $("<div></div>");
        $clearDiv.addClass("clear");

        if ($(".j-productview-content .pager").length === 0) 
        {
            const $pager = $("<div></div>");
            $pager.addClass("pager");

            $(".j-productview-content").append($clearDiv);
            $(".j-productview-content").append($pager);
        }

        let currentPage = 1;

        if ($("#currentPage").length > 0)
            currentPage = parseInt($("#currentPage").val() as string, 10);
        else if ($("#search_page").length > 0)
            currentPage = parseInt($("#search_page").val() as string, 10);

        const count = parseInt($(".searchresultinfo").text().substring(0, $(".searchresultinfo").text().indexOf(" ")), 10);
        const maxPerPage = parseInt($("#default_amount").val() as string, 10);
        const maxPage = Math.ceil(count / maxPerPage);

        if (count > articlesPerPageAmount) 
        {
            let currentStart = 0;

            if (currentPage > 1)
                currentStart = maxPerPage * (currentPage - 1);

            let currentEnd = currentStart + maxPerPage;

            currentStart++;

            if (currentEnd > count)
                currentEnd = count;

            const $newPagingContainer = $("<div></div>");
            $newPagingContainer.addClass("category-paging");

            const $pagingInfo = $("<div class=\"tx tx-alt f-secondary-large margin0 paging-info\"></div>");

            const $countSpan = $("<span></span>");
            $countSpan.text(currentStart + " - " + currentEnd);

            $pagingInfo.append($countSpan);
            $pagingInfo.append(getTranslations().indexPositionText + count);

            const $pagingShowAll = $("<div id=\"show-all-products\">" + getTranslations().showAllProducts + "</div>");

            const $pagingButtons = $("<div></div>");
            $pagingButtons.addClass("paging-buttons");

            const url = document.location.pathname.toLowerCase();
            let query = document.location.search.toLowerCase();

            if (query.length > 0) 
            {
                if (query.indexOf("page=") > -1) 
                {
                    const startIndex = query.indexOf("page=");
                    const endIndex = query.substring(startIndex).indexOf("&");

                    let newQuery = query.substring(0, startIndex - 1);

                    if (endIndex > -1)
                        newQuery += query.substring(startIndex).substring(endIndex);

                    if (newQuery === "?")
                        newQuery = "";

                    if (newQuery.startsWith("&"))
                        newQuery = "?" + newQuery.substring(1, newQuery.length);

                    query = newQuery;
                }
            }

            const fullUrl = url + query;
            let tmpHash = "";

            if (document.location.hash.length > 0)
                tmpHash = document.location.hash;

            let lastItemUrl = fullUrl;
            let previousItemUrl = fullUrl;
            let nextItemUrl = fullUrl;

            if (query.length > 0) 
            {
                lastItemUrl += "&";
                nextItemUrl += "&";

                if (currentPage > 2)
                    previousItemUrl += "&";
            }
            else 
            {
                lastItemUrl += "?";
                nextItemUrl += "?";

                if (currentPage > 2)
                    previousItemUrl += "?";
            }

            lastItemUrl += "page=" + maxPage;
            nextItemUrl += "page=" + (currentPage + 1);

            if (currentPage > 2)
                previousItemUrl += "page=" + (currentPage - 1);

            const $previousItem = $("<a></a>");
            const $nextItem = $("<a></a>");
            const $firstItem = $("<a></a>");
            const $lastItem = $("<a></a>");

            $firstItem.addClass("paging-link");
            $firstItem.addClass("first-page");
            $firstItem.text("1");
            $firstItem.data("page", 1);
            $firstItem.attr("title", String.format(getTranslations().pageTitleText, 1));
            $firstItem.attr("href", fullUrl + tmpHash);

            $lastItem.addClass("paging-link");
            $lastItem.addClass("last-page");
            $lastItem.text(maxPage);
            $lastItem.data("page", maxPage);
            $lastItem.attr("title", String.format(getTranslations().pageTitleText, maxPage));
            $lastItem.attr("href", lastItemUrl + tmpHash);

            $previousItem.addClass("paging-prev");
            $previousItem.attr("title", getTranslations().previousPageTitleText);
            $previousItem.attr("href", previousItemUrl + tmpHash);

            $nextItem.addClass("paging-next");
            $nextItem.attr("title", getTranslations().nextPageTitleText);
            $nextItem.attr("href", nextItemUrl + tmpHash);

            if (currentPage === 1)
                $firstItem.addClass("pagenrlinksel");
            else
                $firstItem.addClass("pagenrlink");

            if (currentPage === maxPage)
                $lastItem.addClass("pagenrlinksel");
            else
                $lastItem.addClass("pagenrlink");

            $previousItem.data("page", currentPage - 1);
            $nextItem.data("page", currentPage + 1);

            if (currentPage > 1)
                $pagingButtons.append($previousItem);

            $pagingButtons.append($firstItem);

            if ((currentPage - 2) > 2) 
            {
                const $spanItem = $("<span></span>");
                $spanItem.addClass("paging-link-text");
                $spanItem.text("...");
                $pagingButtons.append($spanItem);
            }

            let lastDynamicItemIndex = 0;

            for (let i = currentPage - 2; i <= currentPage + 2; i++) 
            {
                if (i > 1 && i < maxPage) 
                {
                    let tmpUrl = fullUrl;

                    if (query.length > 0)
                        tmpUrl += "&";
                    else
                        tmpUrl += "?";

                    tmpUrl += "page=" + i;

                    const $href = $("<a></a>");
                    $href.addClass("paging-link");
                    $href.data("page", i);
                    $href.attr("title", String.format(getTranslations().pageTitleText, i));
                    $href.attr("href", tmpUrl + tmpHash);
                    $href.text(i);

                    if (i === currentPage)
                        $href.addClass("pagenrlinksel");
                    else
                        $href.addClass("pagenrlink");

                    $pagingButtons.append($href);
                    lastDynamicItemIndex = i;
                }
            }

            if (lastDynamicItemIndex < (maxPage - 1)) 
            {
                const $spanItem = $("<span></span>");
                $spanItem.addClass("paging-link-text");
                $spanItem.text("...");
                $pagingButtons.append($spanItem);
            }

            $pagingButtons.append($lastItem);

            if (currentPage < maxPage)
                $pagingButtons.append($nextItem);

            $newPagingContainer.append($pagingInfo);
            $newPagingContainer.append($pagingButtons);
            $newPagingContainer.append($pagingShowAll);
            $newPagingContainer.append($clearDiv.clone());

            if ($(".j-productview-content > .clear").length > 0)
                $(".j-productview-content > .clear").text("");

            $(".j-productview-content .pager .category-paging").remove();
            $(".j-productview-content .pager").append($newPagingContainer);
        }

        if ($(".j-productview-content .w-productcard__holder").length > 0 && $(".j-productview-content .category-paging").length > 0) 
        {
            $(".category-paging .paging-buttons span").off("click");

            $(".category-paging .paging-buttons a").on("click", function () 
            {
                const currentPg = parseInt($("#pn").val() as string, 10);
                const pageNR = $(this).data("page");

                if (currentPg !== pageNR)
                    switchPage(pageNR, true);

                return false;
            });

            if ($("#show-all-products").length > 0) 
            {
                $("#show-all-products").one("click", function () 
                {
                    const currentPg = parseInt($("#pn").val() as string, 10);
                    $("#lazy_load").val(1);
                    $(".pager").remove();

                    if (currentPg > 1)
                        switchPage(1, true);

                    if (origin !== "category")
                        updateFilters(0, false, false, false, origin, true);
                    else
                        updateFilters(0, false, false, false, $("input[name='current_category']").val() as string, true);
                });
            }
        }
    }
    */
}
